import { SmartphoneCharging } from "lucide-react";
import React from "react";

const AcademicCooperation: React.FC = () => {
  return (
    <div
      id="academic-cooperation"
      className="py-24 px-6 bg-white border-t border-gray-200"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-center ml-0 lg:ml-20">
          <div className="lg:w-1/2">
            <div className="max-w-2xl">
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                Deep cooperation with academic universities and research
                institutes
              </h1>

              <div className="space-y-6">
                <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                  Devananta works closely with academic universities and
                  research institutes to advance battery research across
                  materials, cells, BMS, and system-level design.
                </p>

                <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                  Through a collaborative R&D framework, we bring together
                  interdisciplinary expertise spanning electrochemistry,
                  materials science, electronics, mechanical systems, and
                  simulation.
                </p>

                <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                  By combining academic research strengths with applied
                  engineering and digital tools, we develop safer, more
                  reliable, and higher-performance energy solutions.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 mt-12 lg:mt-0">
            <div className="relative w-full max-w-lg mx-auto">
              <div className="relative w-80 h-80 lg:w-96 lg:h-96 mx-auto">
                <div className="absolute inset-0 rounded-full border-8 border-sky-200 shadow-2xl flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-32 h-32 rounded-full mx-auto mb-4 flex items-center justify-center">
                      <SmartphoneCharging className="w-20 h-20 text-sky-500" />
                    </div>
                  </div>
                </div>

                {/* Top-left logo */}
                <div className="absolute top-8 left-8 transform -translate-x-1/4 -translate-y-4">
                  <div className="w-28 h-28 bg-white rounded-full border-4 border-blue-200 shadow-lg flex items-center justify-center">
                    <img
                      src="/logo.png"
                      alt="University Partner 1"
                      className="w-27 h-24 object-contain bg-black rounded-full"
                    />
                  </div>
                </div>

                {/* Top-right logo */}
                <div className="absolute -top-7 right-16 transform translate-x-4">
                  <div className="w-28 h-28 bg-white rounded-full border-4 border-amber-200 shadow-lg flex items-center justify-center">
                    <img
                      src="/iitdh.png"
                      alt="University Partner 3"
                      className="w-24 h-24 object-contain rounded-full"
                    />
                  </div>
                </div>

                {/* Middle-right logo */}
                <div className="absolute bottom-16 -right-6 transform translate-x-7 -translate-y-1/2">
                  <div className="w-28 h-28 bg-white rounded-full border-4 border-green-200 shadow-lg flex items-center justify-center">
                    <img
                      src="/iit.jpg"
                      alt="Research Institute 1"
                      className="w-27 h-27 object-contain bg-black rounded-full"
                    />
                  </div>
                </div>

                {/* Bottom-right logo */}
                <div className="absolute -bottom-2 right-20 transform translate-x-4 translate-y-4">
                  <div className="w-28 h-28 bg-white rounded-full border-4 border-pink-200 shadow-lg flex items-center justify-center">
                    <img
                      src="/igeic.jpg"
                      alt="Research Institute 2"
                      className="w-24 h-24 object-contain rounded-full"
                    />
                  </div>
                </div>

                {/* Bottom-left logo */}
                <div className="absolute bottom-16 -left-2 transform -translate-x-1/8 translate-y-4">
                  <div className="w-28 h-28 bg-white rounded-full border-4 border-purple-200 shadow-lg flex items-center justify-center">
                    <img
                      src="/arcilogo.png"
                      alt="University Partner 2"
                      className="w-27 h-27 object-contain bg-black rounded-full"
                    />
                  </div>
                </div>
              </div>

              <div className="absolute -top-10 -right-10 w-40 h-40 bg-blue-100 rounded-full blur-3xl opacity-50"></div>
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-green-100 rounded-full blur-3xl opacity-50"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-purple-100 rounded-full blur-3xl opacity-30"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademicCooperation;